import CardWrapper from 'components/CardWrapper';
import Form from 'components/Form';
import IntegratedFireInput from 'components/IntegratedFireInput/IntegratedFireInput';
import RainbowEditWrapper from 'components/Layout/RainbowEditWrapper';
import { FireConfigModelType } from 'models/FireConfigModel';
import { fireTypeOptions } from 'models/FireModel';
import React from 'react';
import { FormType } from 'utils/hooks/useForm';

interface FireInputProps {
  form: FormType;
  fireConfigs: FireConfigModelType[];
  handleNewFire: () => void;
}

const FireInput: React.FC<FireInputProps> = ({ form, fireConfigs, handleNewFire }) => {
  return (
    <div className="fire-layout-content__input-container">
      <Form loading={form.loading}>
        <RainbowEditWrapper.Body>
          <CardWrapper>
            <IntegratedFireInput
              input={form.values.input || ''}
              fireType={form.values.fire_type || fireTypeOptions[0]}
              fireConfigId={form.values.fire_config_id || fireConfigs[0]?.id}
              fireConfigs={fireConfigs}
              onInputChange={(value) => form.setField('input', value)}
              onFireTypeChange={(value) => form.setField('fire_type', value)}
              onFireConfigChange={(value) =>
                form.setField('fire_config_id', value)
              }
              onSubmit={handleNewFire}
              loading={form.loading}
            />
          </CardWrapper>
        </RainbowEditWrapper.Body>
      </Form>
    </div>
  );
};

export default FireInput;
